import { Environment, RecordSource, Store } from 'relay-runtime';
import {
  errorMiddleware,
  RelayNetworkLayer,
  retryMiddleware,
  type Middleware,
  type MiddlewareRaw,
  type MiddlewareSync,
  uploadMiddleware,
  urlMiddleware,
} from 'react-relay-network-modern';

const GRAPHQL_URL = '/api/graphql';

let anonymousEnvironment: Environment | undefined;
let environment: Environment | undefined;

/**
 * Get organization slug from current window location
 */
export function getOrganizationSlug(): string | null {
  const { pathname } = window.location;
  const slug = pathname.split('/')[1];
  if (slug == null) {
    return null;
  }

  return slug;
}

/**
 * Get network
 */
export function getNetwork() {
  const middlewares: (Middleware | MiddlewareSync | MiddlewareRaw)[] = [
    uploadMiddleware(),
    urlMiddleware({
      url: GRAPHQL_URL,
      // This is a trick to pass the organization's slug in the headers to the backend.
      // Otherwise, it's impossible for the backend to guess it
      // @ts-expect-error: OK
      headers() {
        const slug = getOrganizationSlug();
        if (slug == null) {
          return {};
        }

        return {
          organizationSlug: slug,
        };
      },
    }),
    retryMiddleware({
      fetchTimeout: 600000, // 600000 miliseconds, 10 minutes
    }),
  ];

  if (__DEV__) {
    middlewares.push(errorMiddleware());
  }

  return new RelayNetworkLayer(middlewares);
}

/**
 * Get anonymous relay environment
 */
export function getAnonymousEnvironment() {
  anonymousEnvironment ??= new Environment({
    network: getNetwork(),
    store: new Store(new RecordSource()),
  });

  return anonymousEnvironment;
}

/**
 * Get anonymous relay environment
 */
export function getEnvironment() {
  environment ??= new Environment({
    network: getNetwork(),
    store: new Store(new RecordSource()),
  });

  return environment;
}
